
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 287.386 287.386"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M62.743 155.437v98.42a10.594 10.594 0 0010.605 10.605c5.854 0 10.605-4.738 10.605-10.605v-98.42c0-5.856-4.751-10.605-10.605-10.605a10.598 10.598 0 00-10.605 10.605z"}}),_c('path',{attrs:{"d":"M29.456 264.582h23.351v-116.85c.064-.56.166-1.119.166-1.693 0-50.412 40.69-91.42 90.698-91.42 50.002 0 90.692 41.008 90.692 91.42 0 .771.113 1.518.228 2.263v116.28h23.354c16.254 0 29.442-13.64 29.442-30.469v-60.936c0-13.878-8.989-25.57-21.261-29.249-1.129-66.971-55.608-121.124-122.45-121.124-66.86 0-121.347 54.158-122.465 121.15C8.956 147.638 0 159.32 0 173.187v60.926c0 16.819 13.187 30.469 29.456 30.469z"}}),_c('path',{attrs:{"d":"M203.454 155.437v98.42c0 5.867 4.748 10.605 10.604 10.605s10.604-4.738 10.604-10.605v-98.42c0-5.856-4.748-10.605-10.604-10.605a10.595 10.595 0 00-10.604 10.605z"}})])
          )
        }
      }
    